import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import ModulesGrid from "./dashboard/ModulesGrid";
import Search from "./search/search";
import Scroll from "./search/scroll";
import SearchList from "./search/search_list";
import ScrollToTop from "react-scroll-to-top";
import api_list from "./search/api_list";
import Footer from "./dashboard/Footer";

function App() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  // console.log("testing deployment");

  useEffect(() => {
    let auth = localStorage.getItem("auth");
    console.log(auth);
    if (
      auth === undefined ||
      auth !== "yes" ||
      auth == null ||
      auth === "null"
    ) {
      navigate("/");
    }
  }, [navigate]);

  const filteredAPI = api_list.filter((api) => {
    return (
      api.name.toLowerCase().includes(search.toLowerCase()) ||
      api.desc.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div className="my_app">
      <ScrollToTop
        smooth
        style={{ backgroundColor: "white" }}
        color="rgba(13,110,253,255)"
      />
      <div className="app_body">
        <Search search_text={setSearch} />
        {search ? (
          <Scroll>
            <SearchList filteredAPI={filteredAPI} />
          </Scroll>
        ) : (
          <ModulesGrid />
        )}
      </div>
      <Footer />
    </div>
  );
}

export default App;
